import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { AspectRatio, Box, Button, Group, Image, Text, rem } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import Link from 'next/link';
export type BlogDetailBannerProps = {
  title: string;
};
export const BlogDetailBanner: React.FC<BlogDetailBannerProps> = ({
  title
}) => {
  const {
    i18n
  } = useLingui();
  return <Box pos="relative">
      <AspectRatio ratio={1320 / 343}>
        <Group inset={0} pos="absolute" align="center" pl={{
        base: 10,
        sm: 20,
        md: 48
      }} py={{
        base: 10,
        sm: 12,
        md: 16
      }}>
          <Box>
            <Button px={0} fw={700} component={Link} href="/blog" variant="transparent" c="var(--text-prime)" fz={{
            base: 10,
            sm: 12
          }} leftSection={<IconArrowLeft size={20} />}>
              {i18n._('BLOG')}
            </Button>

            <Text fz={{
            base: 14,
            md: 18,
            lg: 40
          }} mt={{
            base: 4,
            md: 10
          }} lh={{
            base: rem(14),
            sm: rem(18),
            lg: rem(40)
          }} className={gunterzBold.className} c="var(--text-white)">
              {title}
            </Text>
          </Box>
        </Group>

        <Image src="/assets/blog/blog-banner.png" alt="blogs-banner" />
      </AspectRatio>
    </Box>;
};